import React from 'react';

import { SortableContainer } from 'react-sortable-hoc';
import SortableItem from '../Item/sortable-item';

export default SortableContainer(({
  items,
  renderItem,
  onDelete,
  className
}) => {
  return (
    <div className={className}>
      {items.map((value, index) => (
        <SortableItem
          key={index}
          index={index}
          itemIndex={index}
          item={value}
          canEdit={true}
          canDelete={!value.required}
          onDelete={() => onDelete(index)}
          renderItem={renderItem}
        />
      ))}
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/List/sortable-list.js